import { TokenService } from './../../../../core/auth/services/token.service';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TermsOfUse } from './interface/terms-of-use';
import { AgentService } from 'src/app/components/admin/partners/services/partner.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { Dayjs } from 'dayjs';
import * as dayjs from 'dayjs';
import { AgentModel } from 'src/app/components/admin/partners/models/partner.model';

@Component({
  selector: 'app-modal-terms-conditions',
  templateUrl: './modal-terms-conditions.component.html',
  styleUrls: ['./modal-terms-conditions.component.css']
})
export class ModalTermsConditionsComponent implements OnInit {

  checkedTerms: boolean = false;
  formConfiguration: any;
  accptedTermsTime: Dayjs;
  configurationDefault: any;
  policy: string;
  terms: [];
  contract: string;
  agent: AgentModel

  constructor(
    public bsModalRef: BsModalRef,
    private agentService: AgentService,
    private authService: AuthService,
    private router: Router,
    private tokenService: TokenService
  ) { }

  ngOnInit() {
    const userId = JSON.parse(this.tokenService.getToken(this.tokenService.TOKEN_PERSON_ID));
    this.agentService.getAgentByPerson(userId).subscribe((agent: any) => {
      this.configurationDefault = this.propertyObject(agent.data.configurations);
      var index;
      for (var i = 0; i < agent.data.termsToAccept.length; i++) {
        if (agent.data.termsToAccept[i].name == 'TerminationTerm') {
          index = i;
        }
      }
      delete agent.data.termsToAccept[index];

      if (agent.data.operatingMode === 1) {
        this.terms = agent.data.termsToAccept.filter((element: any) => {
          return element.name !== 'PartnerContractPJ';
        });
      } else {
        this.terms = agent.data.termsToAccept.filter((element: any) => {
          return element.name !== 'PartnerContract';
        });
      }
    });
  }

  onOpenWhatsApp() {
    window.open('https://api.whatsapp.com/send?phone=551130030694', '_blank');
  }

  onNotNow() {
    this.logout();
    this.bsModalRef.content.callback(null);
    this.bsModalRef.hide();
    this.router.navigate(['/login']);
  }

  onAcceptTerms() {
    const terms: TermsOfUse[] = [];
    this.terms.forEach((element: any) => {
      terms.push({
        termId: element.id,
        dateTime: this.accptedTermsTime.toISOString(),
        dateTimeStr: this.accptedTermsTime.format('YYYY-MM-DDTHH:mm:ss [GMT]Z')
      })
    });

    const request = { terms };

    this.agentService.saveTermsConditions(request).subscribe((result: any) => {
      if (result) {
        this.bsModalRef.content.callback(true);
        this.bsModalRef.hide();
      }
    }, err => {
      this.onNotNow();
    });
  }

  getTermNameToTranslate(name: string) {
    switch (name) {
      case 'TermsAndConditionsPdf':
        return 'modal-terms.link-term'
        break;
      case 'PrivacyPolicy':
        return 'modal-terms.link-policy'
        break;
      case 'PartnerContract':
        return 'modal-terms.link-contract'
        break;
      case 'PartnerContractPJ':
        return 'modal-terms.link-contract-pj'
        break;
      case 'TerminationTerm':
        return 'modal-terms.termination-term'
        break;
      default:
        break;
    }
  }

  setAcceptedTerms(): void {
    this.checkedTerms = !this.checkedTerms;
    const dateTimezone = dayjs(new Date());
    this.accptedTermsTime = dateTimezone;
  }

  propertyObject<T>(arrConfig: any): T {
    return arrConfig.reduce((obj, item) => (
      {
        ...obj,
        [item.name]: item.value
      }), {})
  }

  private logout() {
    this.authService.logout();
  }

  public decline(): void {
    this.bsModalRef.content.callback(null);
    this.bsModalRef.hide();
  }

  public accept(): void {
    this.bsModalRef.content.callback(true);
    this.bsModalRef.hide();
  }

  public dismiss(): void {
    this.bsModalRef.content.callback(null);
    this.bsModalRef.hide();
  }
}
